module.exports = __webpack_public_path__ + "media/entities/40-ccdb0f17.png";